export const MAYBE_FETCH_LISTING_OFFER = '@@od/store/resaleClosingDashboard/maybeFetchListingOffer';
export const BEGIN_LOADING_LISTING_OFFER =
  '@@od/store/resaleClosingDashboard/beginLoadingListingOffer';
export const RECEIVE_LISTING_OFFER = '@@od/store/resaleClosingDashboard/receiveListingOffer';
export const ERROR_LISTING_OFFER = '@@od/store/resaleClosingDashboard/errorListingOffer';
export const CLEAR_LISTING_OFFER = '@@od/store/resaleClosingDashboard/clearListingOffer';

export const MAYBE_FETCH_LISTING_OFFERS =
  '@@od/store/resaleClosingDashboard/maybeFetchListingOffers';
export const BEGIN_LOADING_LISTING_OFFERS =
  '@@od/store/resaleClosingDashboard/beginLoadingListingOffers';
export const RECEIVE_LISTING_OFFERS = '@@od/store/resaleClosingDashboard/receiveListingOffers';
export const ERROR_LISTING_OFFERS = '@@od/store/resaleClosingDashboard/errorListingOffers';
export const CLEAR_LISTING_OFFERS = '@@od/store/resaleClosingDashboard/clearListingOffers';

export const DOWNLOAD_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/downloadChecklistDocument';

export const UPLOAD_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/uploadChecklistDocument';
export const BEGIN_UPLOAD_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/beginUploadChecklistDocument';
export const SUCCESS_UPLOAD_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/successUploadChecklistDocument';
export const ERROR_UPLOAD_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/errorUploadChecklistDocument';

export const REMOVE_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/removeChecklistDocument';
export const BEGIN_REMOVE_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/beginRemoveChecklistDocument';
export const SUCCESS_REMOVE_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/successRemoveChecklistDocument';
export const ERROR_REMOVE_CHECKLIST_DOCUMENT =
  '@@od/store/resaleClosingDashboard/errorRemoveChecklistDocument';

export const UPDATE_CHECKLIST_ITEM = '@@od/store/resaleClosingDashboard/updateChecklistDocument';

export const SUBMIT_CHANGE_CLOSING_DATE_REQUEST =
  '@@od/store/resaleClosingDashboard/submitChangeClosingDateRequest';
export const RECEIVE_CUSTOMER_REQUEST = '@@od/store/resaleClosingDashboard/receiveCustomerRequest';

export const REQUEST_GENERATE_SELLER_RESPONSE =
  '@@od/store/resaleClosingDashboard/requestGenerateSellerResponse';
export const ERROR_REQUEST_GENERATE_SELLER_RESPONSE =
  '@@od/store/resaleClosingDashboard/errorRequestGenerateSellerResponse';
export const SUCCESS_REQUEST_GENERATE_SELLER_RESPONSE =
  '@@od/store/resaleClosingDashboard/successRequestGenerateSellerResponse';

export const TRACK_EVENT = '@@od/store/resaleClosingDashboard/trackEvent';

export const UPDATE_BUYER_REPAIR_PREFERENCES =
  '@@od/store/resaleClosingDashboard/updateBuyerRepairPreferences';
export const BEGIN_UPDATE_BUYER_REPAIR_PREFERENCES =
  '@@od/store/resaleClosingDashboard/beginUpdateBuyerRepairPreferences';
export const SUCCESS_UPDATE_BUYER_REPAIR_PREFERENCES =
  '@@od/store/resaleClosingDashboard/successUpdateBuyerRepairPreferences';
export const ERROR_UPDATE_BUYER_REPAIR_PREFERENCES =
  '@@od/store/resaleClosingDashboard/errorUpdateBuyerRepairPreferences';
export const SUBMIT_BUYER_REPAIR_PREFERENCES =
  '@@od/store/resaleClosingDashboard/submitBuyerRepairPreferences';

export const BEGIN_CLAIM_LISTING_OFFER_BY_TOKEN =
  '@@od/store/resaleClosingDashboard/beginClaimListingOfferByToken';
export const ERROR_CLAIM_LISTING_OFFER_BY_TOKEN =
  '@@od/store/resaleClosingDashboard/errorClaimListingOfferByToken';
export const SUCCESS_CLAIM_LISTING_OFFER_BY_TOKEN =
  '@@od/store/resaleClosingDashboard/successClaimListingOfferByToken';
